import { OnboardingContextProvider } from "./contexts/onboardingContext";
import Skeleton from "./skeleton";
import { Route, Routes } from "react-router-dom";
import {
  PROFILE_INFO_PATH,
  ProfileInfo,
  CONTACT_INFO_PATH,
  ContactInfo,
  ID_VERIFICATION_PATH,
  IdVerification,
  BACKGROUND_CHECK_PATH,
  BackgroundCheck,
  PAYMENT_INFO_PATH,
  PaymentInfo,
  TAX_INFO_PATH,
  TaxInfo,
} from "./routes";
import { ProfileInfoProvider } from "../employee-profile/contexts/ProfileInfoContext";

const Onboarding = () => (
  <OnboardingContextProvider>
    <Routes>
      <Route
        path={PROFILE_INFO_PATH}
        element={
          <ProfileInfoProvider>
            <ProfileInfo />
          </ProfileInfoProvider>
        }
      />
      <Route path={CONTACT_INFO_PATH} element={<ContactInfo />} />
      <Route path={ID_VERIFICATION_PATH} element={<IdVerification />} />
      <Route path={BACKGROUND_CHECK_PATH} element={<BackgroundCheck />} />
      <Route path={PAYMENT_INFO_PATH} element={<PaymentInfo />} />
      <Route path={TAX_INFO_PATH} element={<TaxInfo />} />
      <Route path="/" element={<Skeleton />} />
    </Routes>
  </OnboardingContextProvider>
);

export default Onboarding;
